module.exports = __webpack_public_path__ + "static/media/podcastCover.3a55f8da.png";